import React from 'react';
import PropTypes from 'prop-types';
import './FormTextarea.scss';

const FormTextarea = (props) => {
  const {
    name, label, autotestClass, placeholder, maxLength, required, input, rows, meta, meta: { touched, error }
  } = props;
  const errorClass = meta && touched && error ? 'form-textarea-error ' : '';
  return (
    <div className="form-textarea-container relative">
      <label htmlFor={name}>{label}</label>
      {required && <span className="text-area-required-text">Required</span>}
      <textarea
        className={`${errorClass}form-textarea form-control ${autotestClass}`}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={rows}
        {...input}
      />
      {errorClass &&
      <span className="text-area-validation-error">{props.meta.error}</span>
      }
    </div>
  );
};

FormTextarea.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autotestClass: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  input: PropTypes.object,
  meta: PropTypes.object,
  rows: PropTypes.number
};

export default FormTextarea;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormTextarea/FormTextarea.js
 **/